import { Input, InputGroup, InputLeftElement } from '@chakra-ui/react';
import { useSelector } from 'react-redux';

/**
 * @typedef {Object} ChakraInputProps
 * @property {React.RefObject<HTMLInputElement>} customRef
 * @property {string} displayPrefix - Prefix to display before the input
 * @property {ChakraInputProps & import('@chakra-ui/react').InputProps} props
 * @param {ChakraInputProps} customRef
 * @param {string} displayPrefix
 * @param {import('@chakra-ui/react').InputProps} rest
 * @returns
 */
export default function ChakraInput({ customRef, displayPrefix, ...rest }) {
    const { darkMode } = useSelector((state) => state.settings);

    const inputProps = {
        ...rest,
        ref: customRef,
        color: darkMode ? 'dark.textDark' : null,
        background: darkMode ? 'dark.bgDark' : null,
        borderColor: darkMode ? 'dark.tcap-borderGray' : null,
    };

    // If displayPrefix is provided, wrap input in InputGroup with InputLeftElement
    if (displayPrefix) {
        return (
            <InputGroup>
                <InputLeftElement
                    pointerEvents="none"
                    color="gray.400"
                    fontSize="md"
                    width="auto"
                    sx={{
                        paddingBottom: '10px',
                        paddingLeft: '12px',
                        paddingRight: '4px',
                        whiteSpace: 'nowrap',
                    }}>
                    {displayPrefix}
                </InputLeftElement>
                <Input
                    {...inputProps}
                    sx={{
                        ...inputProps.sx,
                        paddingLeft: `${displayPrefix.length * 0.6 + 1}rem !important`,
                    }}
                />
            </InputGroup>
        );
    }

    return <Input {...inputProps} />;
}
